import { DEFAULT_LOCAL_LANGUAGE } from '../constants/constants';

export const getUserAgentLanguage = (): string =>
  navigator.languages !== undefined &&
  Array.isArray(navigator.languages) &&
  navigator.languages.length > 0
    ? navigator.languages[0]
    : navigator.language || DEFAULT_LOCAL_LANGUAGE;
